import { render } from "./CognitoLoginPasswordChange.vue?vue&type=template&id=13085738&scoped=true"
import script from "./CognitoLoginPasswordChange.vue?vue&type=script&lang=js"
export * from "./CognitoLoginPasswordChange.vue?vue&type=script&lang=js"

import "./CognitoLoginPasswordChange.vue?vue&type=style&index=0&id=13085738&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13085738"]])

export default __exports__